import {Component, computed, Inject, OnInit, signal} from '@angular/core';
import {ConfirmDialogService} from '../../../services/confirm-dialog-service/confirm-dialog.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TailChargeService} from '../../../services/tail-charge.service';
import {Inspection} from '../../../classes/inspection';
import {TailCharge} from '../../../classes/tail-charge';
import {MatFormField, MatHint, MatInput, MatLabel, MatPrefix, MatSuffix} from "@angular/material/input";
import {DecimalInputDirective} from "../../../directives/decimal-input.directive";
import {FormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {DecimalPipe} from "@angular/common";

export class TailChargeDialogData {
    tailCharge: TailCharge;
    inspection: Inspection;
    totalPrice: number;
}

@Component({
    selector: 'app-tail-charge-dialog',
    templateUrl: './tail-charge-dialog.component.html',
    styleUrls: ['./tail-charge-dialog.component.scss'],
    imports: [
        MatFormField,
        MatLabel,
        MatInput,
        DecimalInputDirective,
        FormsModule,
        MatHint,
        MatButton,
        MatIconButton,
        DecimalPipe,
        MatSuffix,
        MatPrefix
    ]
})
export class TailChargeDialogComponent implements OnInit {

    public readonly tailCharge = signal<TailCharge>(null);
    public readonly dialogTitle = computed(() =>
        this.tailCharge()?.id ? 'Staartkosten Wijzigen' : 'Staartkosten Toevoegen'
    );
    public readonly buttonLabel = computed(() =>
        this.tailCharge()?.id ? 'Wijzigen' : 'Toevoegen'
    );
    public readonly hasId = computed(() => !!this.tailCharge()?.id);

    percentage: number;
    comment: string = '';

    constructor(
        private tailChargeService: TailChargeService,
        private confirmDialogService: ConfirmDialogService,
        public dialogRef: MatDialogRef<TailChargeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public tailChargeDialogData: TailChargeDialogData
    ) {
    }

    ngOnInit(): void {
        this.tailCharge.set(this.tailChargeDialogData.tailCharge);
        // Fix floating point precision: round to 3 decimal places
        this.percentage = Math.round((this.tailCharge().number * 100) * 1000) / 1000;
        this.comment = this.tailCharge().comment || '';
        if (!this.tailCharge) {
            this.tailCharge.set(new TailCharge());
        }
    }

    save() {
        const originalTailCharge = this.tailCharge();
        originalTailCharge.inspection_id = this.tailChargeDialogData.inspection.id;
        originalTailCharge.number = this.percentage / 100;
        originalTailCharge.comment = this.comment;

        this.tailChargeService.save(originalTailCharge).subscribe(tailCharge => {
            originalTailCharge.id = tailCharge.data.id;
            this.dialogRef.close({updated: originalTailCharge});
        });
    }

    delete() {
        this.confirmDialogService.confirm(
            'Verwijderen',
            'Weet u zeker dat u deze staartkosten wilt verwijderen?',
            'Ja',
            'Nee').then(
            () => {
                if (this.tailCharge().id) {
                    this.tailChargeService.delete(this.tailCharge().id).subscribe(result => {
                        this.dialogRef.close(true);
                    }, () => {

                    });
                } else {
                    this.dialogRef.close(true);
                }
            }, () => {

            }
        );
    }

    close() {
        this.dialogRef.close((!this.tailCharge().id));
    }

}
